import { cores } from "../../Func_genericas/valores_estaticos";
import { CustomThemeProvider } from "../../Styles/theme/customThemeprovider";
import HomeViewTecnico from "../../Styles/layout/homeViewTecnico";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { useContext, useEffect, useState } from "react";
import { func_print } from "../../Func_genericas/func_print";
import {  get } from "../../Services/tokenConfig";
import { AuthContext } from "../../AuthContext/AuthContext";
import { useLocation } from "react-router-dom";
import { Snackbar } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Alert } from "../../Components/Alert/Alert";
import { IMaquina } from "../../Interfaces/equipamentos/equipamentos";
import { Modaladdequipamentos } from "./add_equipamento";
import { loader } from "../../Func_genericas/loader";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(2),
    },
    label: {
      display: "flex",
      flexWrap: "wrap",
      "& > *": {
        // margin: theme.spacing(1),
        // width: theme.spacing(16),
        // height: theme.spacing(16),
        // minWidth: 325,
      },
    },
    header: {
      textAlign: "center",
      background: "#FAFAFA",
      color: "#7e2706",
    },
    picker: {
      color: "#7e2706",
      "&.Mui-checked": {
        color: "#ccafa3",
      },
    },
    tabs: {
      "& .MuiTabs-indicator": {
        backgroundColor: cores.cor1,
        height: 3,
      },
      "& .MuiTab-root.Mui-selected": {
        color: cores.cor1,
      },
    },
  })
);
function Equipamentos() {

  const classes = useStyles();

  const auth = useContext(AuthContext);
  const location = useLocation();


  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [lista_de_equipamentos, set_lista_de_equipamentos] = useState<IMaquina[]>([]);

  const [flag_open_modal_equipamentos, set_flag_open_modal_equipamentos] = useState<boolean>(false);
  const [flag_open_modal_equipamentos_ver_mais, set_flag_open_modal_equipamentos_ver_mais] = useState<boolean>(false);
  const [flag_open_modal_equipamentos_edit, set_flag_open_modal_equipamentos_edit] = useState<boolean>(false);
  const [flag_open_modal_equipamentos_add, set_flag_open_modal_equipamentos_add] = useState<boolean>(false);
  const [obj_new_equipamentos, set_obj_new_equipamentos] = useState<IMaquina>()

  const [openSnackSuccess, setOpenSnackSuccess] = useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const [hover, setHover] = useState<{ flag: boolean; id: number | null }>({ flag: false, id: null });

  const get_info = async () => {
    try {
      setIsLoading(true);
      let res = await get(auth.token.cookie_token, '/api/maquinas/all/' + location.state);
      set_lista_de_equipamentos(res.data.result)

      setIsLoading(false);

    } catch (error) {
      func_print("get_info", error, true);
      setIsLoading(false);
    }
  }


  useEffect(() => {
    (async () => {
      await get_info();
    })();
  }, []);



  function getDateStatusColor(targetDate: Date, warningDays: number = 3): string {
    const now = new Date();

    // diferença em milissegundos
    const diffMs = targetDate.getTime() - now.getTime();

    // converter para dias
    const diffDays = diffMs / (1000 * 60 * 60 * 24);

    if (diffDays < 0) {
      // já passou
      return "red";
    } else if (diffDays <= warningDays) {
      // está perto
      return "orange";
    } else {
      // ainda está longe
      return "gray"; // ou "black"
    }
  }

  return (
    <CustomThemeProvider>
      <Snackbar
        open={openSnackSuccess}
        autoHideDuration={2000}
        onClose={() => setOpenSnackSuccess(false)}
      >
        <Alert
          onClose={() => setOpenSnackSuccess(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSnackError}
        autoHideDuration={2000}
        onClose={() => setOpenSnackError(false)}
      >
        <Alert
          onClose={() => setOpenSnackError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {message}

        </Alert>
      </Snackbar>
      {
        flag_open_modal_equipamentos === true &&
        <Modaladdequipamentos
          list_maquina={lista_de_equipamentos}
          flag_open_modal={flag_open_modal_equipamentos}
          set_flag_open_modal={set_flag_open_modal_equipamentos}
          setMessage={setMessage}
          setOpenSnackSuccess={setOpenSnackSuccess}
          setOpenSnackError={setOpenSnackError}
          set_list_maquina={set_lista_de_equipamentos}
          flag_open_modal_ver_mais={flag_open_modal_equipamentos_ver_mais}
          set_flag_open_modal_ver_mais={set_flag_open_modal_equipamentos_ver_mais}
          flag_open_modal_edit={flag_open_modal_equipamentos_edit}
          set_flag_open_modal_edit={set_flag_open_modal_equipamentos_edit}
          flag_open_modal_add={flag_open_modal_equipamentos_add}
          set_flag_open_modal_add={set_flag_open_modal_equipamentos_add}
          set_obj_new_maquina={set_obj_new_equipamentos}
          obj_new_maquina={obj_new_equipamentos}
        />
      }
      <div className={classes.root}>
        <HomeViewTecnico title=" Equipamentos" />

        <main className={classes.contents}>
          <div className={classes.toolbars} />
          <div className={`${classes.label} p-4`}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1
            }}>
              {
                isLoading === true ?
                  loader() : <>

                    <div className="p-5">
                      <button
                        type="button"
                        onClick={() => {
                          set_flag_open_modal_equipamentos(true)
                          set_flag_open_modal_equipamentos_edit(true)
                          set_flag_open_modal_equipamentos_add(true)
                          set_obj_new_equipamentos(undefined)
                        }}
                        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                      >
                        <AddIcon sx={{ fontSize: 18 }} />
                        Adicionar Equipamento
                      </button>
                    </div>
                    <div style={{
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>

                      {
                        lista_de_equipamentos.length > 0 ?

                          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                            {lista_de_equipamentos.map((equipamento, key) => {
                                const isSelected = obj_new_equipamentos?.id_maquina === equipamento.id_maquina;
                                const isHovered = hover.flag && hover.id === equipamento.id_maquina;
                              
                              return (
                                <div
                                  key={key}
                                  // className="w-full max-w-[250px] rounded-2xl border border-gray-200 bg-stone-50 p-4 shadow-sm"
                                  className={`
                                    flex flex-col items-center justify-center w-[150px] min-w-[150px] w-full max-w-[250px] p-4 rounded-xl cursor-pointer
                                    transition-all duration-200
                                    ${isSelected ? 'ring-2 ring-[#c94f1e] bg-[#f2d1c2]/30' : 'bg-gray-50/80'}
                                    ${isHovered ? 'shadow-md' : 'shadow-sm'}
                                  `}
                                  onMouseEnter={() => setHover({ flag: true, id: equipamento.id_maquina })}
                                  onMouseLeave={() => setHover({ flag: false, id: equipamento.id_maquina })}
  
                                  onClick={() => {
                                    set_flag_open_modal_equipamentos(true)
                                      set_obj_new_equipamentos(equipamento)
                                      set_flag_open_modal_equipamentos_ver_mais(true)
                                      set_flag_open_modal_equipamentos_edit(false)
                                      set_flag_open_modal_equipamentos_add(false)
                                  }}
                                >
                                  <div className="space-y-2 text-sm">
                                    <div className="flex items-center justify-between gap-3">
                                      <span className="text-gray-500">Nome</span>
                                      <span className="text-gray-800 font-medium truncate">
                                        {equipamento.nome || '-'}
                                      </span>
                                    </div>
                                    <div className="flex items-center justify-between gap-3">
                                      <span className="text-gray-500">Matrícula</span>
                                      <span className="text-gray-800 font-medium truncate">
                                        {equipamento.matricula || '-'}
                                      </span>
                                    </div>
                                    <div className="flex items-center justify-between gap-3">
                                      <span className="text-gray-500">Tipo</span>
                                      <span className="text-gray-800 font-medium truncate">
                                        {equipamento.tipo || '-'}
                                      </span>
                                    </div>
                                    <div className="flex items-center justify-between gap-3">
                                      <span className="text-gray-500">Marca</span>
                                      <span className="text-gray-800 font-medium truncate">
                                        {equipamento.marca || '-'}
                                      </span>
                                    </div>
                                    <div className="flex items-center justify-between gap-3">
                                      <span className="text-gray-500">€/h</span>
                                      <span className="text-gray-800 font-medium">
                                        {equipamento.custo_hora ?? 0}
                                      </span>
                                    </div>
                                    <div className="flex items-center justify-between gap-3">
                                      <span className="text-gray-500">Tipo de Combustível</span>
                                      <span className="text-gray-800 font-medium text-right">
                                        {equipamento.combustivel_tipo || '-'}
                                      </span>
                                    </div>

                                    <div className="flex items-center justify-between gap-3">
                                      <span className="text-gray-500">Estado</span>
                                      <span className="text-gray-800 font-medium text-right">
                                        {equipamento.estado || '-'}
                                      </span>
                                    </div>
                                    <div className="flex items-center justify-between gap-3">
                                      <span className="text-gray-500">Validade Seguro</span>
                                      {
                                        equipamento.seguro_validade ? (
                                          <span
                                            className="font-medium text-right"
                                            style={{
                                              color: getDateStatusColor(new Date(equipamento.seguro_validade)),
                                            }}
                                          >
                                            {equipamento.seguro_validade}
                                          </span>
                                        ) : (
                                          <span className="text-gray-800 font-medium text-right">
                                            -
                                          </span>
                                        )
                                      }
                                      {/* <span className="text-gray-800 font-medium text-right">
                                  {equipamento.seguro_validade || '-'}
                                </span> */}
                                    </div>
                                    <div className="flex items-center justify-between gap-3">
                                      <span className="text-gray-500">Validade Inspeção</span>
                                      {
                                        equipamento.inspecao_validade ? (
                                          <span
                                            className="font-medium text-right"
                                            style={{
                                              color: getDateStatusColor(new Date(equipamento.inspecao_validade)),
                                            }}
                                          >
                                            {equipamento.inspecao_validade}
                                          </span>
                                        ) : (
                                          <span className="text-gray-800 font-medium text-right">
                                            -
                                          </span>
                                        )
                                      }
                                      {/* <span className="text-gray-800 font-medium text-right">
                                  {equipamento.inspecao_validade || '-'}
                                </span> */}
                                    </div>
                                    <div className="flex items-center justify-between gap-3">
                                      <span className="text-gray-500">Horimetro Atual</span>
                                      <span className="text-gray-800 font-medium text-right">
                                        {equipamento.horimetro_atual || '-'}
                                      </span>
                                    </div>
                                    <div className="flex items-center justify-between gap-3">
                                      <span className="text-gray-500">Data da Próxima Manutenção</span>
                                      {
                                        equipamento.proxima_manutencao_data ? (
                                          <span
                                            className="font-medium text-right"
                                            style={{
                                              color: getDateStatusColor(new Date(equipamento.proxima_manutencao_data)),
                                            }}
                                          >
                                            {equipamento.proxima_manutencao_data}
                                          </span>
                                        ) : (
                                          <span className="text-gray-800 font-medium text-right">
                                            -
                                          </span>
                                        )
                                      }
                                      {/* <span className="text-gray-800 font-medium text-right">
                                  {equipamento.proxima_manutencao_data || '-'}
                                </span> */}
                                    </div>
                                  </div>

                                  <div
                                  className={`mt-2 w-full h-1 rounded-full ${isSelected ? 'bg-[#c94f1e]' : 'bg-gray-200'}`}
                                />


                                 
                                </div>
                              )
                            })}
                          </div>
                          : <></>
                      }

                    </div>
                  </>}
            </div>



          </div>
        </main>
      </div>


     

    </CustomThemeProvider>
  )



}

export default Equipamentos;
